module.exports = __webpack_public_path__ + "static/media/light-arrow-down.8fadfa9c.svg";